import { render, staticRenderFns } from "./NoRooms.vue?vue&type=template&id=540b840c&"
import script from "./NoRooms.vue?vue&type=script&lang=js&"
export * from "./NoRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports